//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */
import item from "./Item.vue";
import { pricingPackageList as planBg } from "../../../const/plan";
// import { cancel } from '../../../services/payment'
import { mapGetters } from "vuex";
import {
  CURRENT_USER_PLAN_LIST_SIMPLE,
  CURRENT_USER_INFO_SIMPLE,
  PAYPAL_INFO,
  DEVICE,
} from "../../../store/mutation-types";
// import { showErrorMsg } from '../../../utils/error'
import moment from "moment";
import MemberDes from "../../../components/team_member/des/Index.vue";
import MemberDes2 from "../../../components/team_member/des2/Index.vue";
import { dateFormat } from "../../../utils/plugin_helper";
import _ from "lodash";
export default {
  name: "ActivePricingPackageComponent",
  components: { item, MemberDes, MemberDes2 },
  data() {
    return {
      planBg,
      memberDesOpen: false,
      memberDesOpen1: false,
    };
  },
  computed: {
    ...mapGetters({
      planList: CURRENT_USER_PLAN_LIST_SIMPLE,
      user: CURRENT_USER_INFO_SIMPLE,
      device: DEVICE,
    }),
    /**
     * 处理plan列表,只显示价格更高的项目
     */
    list() {
      let list;
      const planList = _.cloneDeep(this.planList);
      // 判断是否需要过滤
      if (this.filter) {
        const currentPlanIndex = planList.findIndex((p) => p.active);
        list = planList.slice(currentPlanIndex);
      } else {
        list = planList;
      }
      if (this.only) {
        // 如果only指定则只显示only
        list = list.filter(
          (item) => item.name.toLowerCase() === this.only.toLowerCase()
        );
      }
      if (this.queryType === "free2basicpromo") {
        list = list.filter((item) => item.price !== 0);
      }
      return list;
    },
    /**
     * 年费优惠信息
     */
    yearDiscounts() {
      // 如果是only 只显示某个plan的模式 则不显示年付
      if (this.only) {
        return null;
      }
      // 判断当前用户是不是月付用户，如果是则显示年付优惠信息，否则不显示
      if (this.user.plan.price === 0) {
        return null;
      }
      if (this.user.plan.billingInterval === 12) {
        return null;
      }
      const currentPlan = this.planList.find((p) => p.active);
      if (!currentPlan) {
        return;
      }
      return {
        name: currentPlan.name, // 当前付费计划名称
        discountPrice: `$${
          (currentPlan.billingCycles[1].totalUsdPriceNum -
            currentPlan.billingCycles[0].totalUsdPriceNum / 12) *
          12
        }`, // 优惠价格
      };
    },
    /**
     * 计算激活右侧文案
     */
    yourPlanText() {
      let yourPlanText = this.$t("planUpgradePage.yourPlan");
      if (this.type === "renew") {
        yourPlanText = this.$t("planUpgradePage.renewPageTitle");
      }
      return yourPlanText;
    },
    /**
     * 是否全部显示激活
     */
    activeAll() {
      // 如果是续费页面则所均可点击
      return this.type !== "renew";
    },
  },
  props: {
    /** 现在跳转upgrade页面有各种显示方式 free2basicpromo 为非free都显示 */
    queryType: {
      type: String,
      default: "",
    },
    /**
     * 是否全部都可点击(激活plan也可点击)
     */
    allClick: {
      type: Boolean,
      default: false,
    },
    /**
     * 是否过滤掉低等级状态
     */
    filter: {
      type: Boolean,
      default: true,
    },
    /**
     * 类型 normal(普通) renew(续费用户)
     */
    type: {
      type: String,
      default: "normal",
    },
    only: {
      type: String,
      default: "",
    },
  },
  methods: {
    /**
     * 升级年费点击
     */
    updateYearClick() {
      this.$router.push({
        name: "PaymentSubscriptionPage",
        params: { name: this.yearDiscounts.name },
        query: { filter: "year" }, // 只显示年费
      });
    },
    /**
     * 用户点击条目点击事件
     * @param item 单条记录
     */
    async itemClick(item, index) {
      // this.$router.push({ name: 'CancelFeedbackPage' })
      // return
      // const commentUrl = `https://mapiz.wufoo.com/forms/rjs071s1ckyx2i/def/Field103=${this.user.email}`
      // 点击支付清空paypal info 信息
      this.$store.commit(PAYPAL_INFO, null);
      // 如果是续费则所有点击都跳转付费页面
      if (this.type === "renew") {
        this.$router.push({
          name: "PaymentSubscriptionPage",
          params: { name: item.name },
        });
      }
      if (this.only) {
        this.$router.push({
          name: "PaymentSubscriptionPage",
          params: { name: item.name },
          query: { only: this.only },
        });
        return;
      }
      // 如果全部可点击，点击的还是free且当前激活状态不是free则弹提示
      if (!this.filter && !item.active && item.price === 0) {
        // 判断是否已进行过取消
        if (this.user.plan.cancelTime) {
          // your-xxx-planyearly变量-will-change-to-free-plan-on-may-30-2019
          const date = dateFormat({
            date: moment(this.user.plan.currentPeriodEnd),
            format: "MMM DD, YYYY",
          });
          const text = this.$t("planUpgradePage.cancelPlanAgainText", {
            planName: this.user.plan.nameWithInterval,
            date,
          });
          await this.$alert.show({
            cancelText: "", // 不知道什么鬼。。总是被自动设置成cancel。。
            title: this.$t("common.cancelled"),
            text: text,
            yesText: this.$t("common.ok"),
          });
          return;
        }
        const date = dateFormat({
          date: moment(this.user.plan.currentPeriodEnd),
          format: "MMM DD, YYYY",
        });
        const cancelText = this.$t("planUpgradePage.cancelPlanText", {
          planName: this.user.plan.nameWithInterval,
          date,
        });
        await this.$confirm.show({
          title: this.$t("planUpgradePage.cancelTitle"),
          text: cancelText,
          cancelText: this.$t("common.no"),
        });
        // 2020.3.24 取消跳转到新的页面
        this.$router.push({ name: "CancelFeedbackPage" });
        // try {
        //   this.$loading.show()
        //   await cancel()
        //   if (this.device === 'android') {
        //     // eslint-disable-next-line
        //     AndroidWebView.startBrowser(commentUrl)
        //   } else {
        //     console.log('非安卓设备打开')
        //     window.open(commentUrl, '_blank')
        //   }
        //   this.$router.push({ name: 'PaymentHistoryPage' })
        //   this.$toast.show({ message: this.$t('common.success') })
        // } catch (e) {
        //   showErrorMsg(e)
        // } finally {
        //   this.$loading.hide()
        // }
        return;
      }
      // 2021.8.25 判断当前订阅为VIP则进入订阅页面 并且强制strip
      if (
        this.user.plan.name === "VIP" &&
        this.planList.findIndex((p) => p.name === "VIP") === -1
      ) {
        this.$router.push({
          name: "PaymentSubscriptionPage",
          params: { name: item.name },
          query: { payment_method: "6" },
        });
        return;
      }
      if (this.user.plan.level > this.planList[index].level) {
        if (
          this.user.paymentMethod === 1 ||
          (this.$route.query.type === "downgrade" &&
            this.user.paymentMethod !== 4)
        ) {
          // stripe无脑支持降级 如果是通过降级链接则判断非google play可以降级
          this.$router.push({
            name: "PaymentSubscriptionPage",
            params: { name: item.name },
            query: { type: this.$route.query.type },
          });
          return;
        }
        await this.$confirm.show({
          title: this.$t("planUpgradePage.downgradePlanTitle"),
          text: this.$t("planUpgradePage.downgradePlanText"),
          yesText: this.$t("common.contactUs"),
          cancelText: this.$t("common.cancel"),
        });
        window.open(process.env.CONTACT_US, "_blank");
        return;
      }
      // 当全部可点击，且点击条目处于激活状态则跳转到 my plan页面
      if (this.allClick && item.active) {
        this.$router.push({ name: "MyPlanPage" });
        return;
      }
      // 如果不是全部可点击状态，则点击激活项无法应
      if (!this.allClick && item.active) {
        return;
      }
      this.$router.push({
        name: "PaymentSubscriptionPage",
        params: { name: item.name },
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/active/pricing_package/Index.vue